import type { ScheduleFrequency } from '@risksmart-app/domain/src/types/consts';

/**
 * The frequencies the form offers, in the order it offers them. The single
 * runtime enumeration of `ScheduleFrequency`: `satisfies` fails to compile when
 * a frequency is added to the type and not here, which a plain array of the
 * union would not.
 */
export const SCHEDULE_FREQUENCIES = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
} as const satisfies Record<ScheduleFrequency, ScheduleFrequency>;

/**
 * The `scheduler.frequencies` key each frequency reads back through. Shared by
 * the register's Frequency column and the create form's summary so the two name
 * a cadence identically; the interval reaches the locale as i18next's `count`,
 * so "Monthly" vs "Every 3 months" is a plural form rather than a branch —
 * other languages split their plural categories differently.
 *
 * There are deliberately no friendly aliases like "Quarterly" for `MONTHLY`/3:
 * the form cannot express them, so showing one would name a cadence nobody
 * selected.
 */
export const FREQUENCY_KEY: Record<
  ScheduleFrequency,
  'daily' | 'monthly' | 'weekly' | 'yearly'
> = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};
